import type { DocumentNode } from 'graphql';
import gql from 'graphql-tag';

export const GET_APP_NAME: DocumentNode = gql`
	query app($id: ID!) {
		app(id: $id) {
			name
		}
	}
`;
